export default __webpack_public_path__ + "8b29112bd827ca3e3f09077e1382f1fe.png";